// components
import dropcap from '../components/dropcap';
import youtubeBg from '../components/youtube-bg';
import sharer from '../components/sharer';

// modules
import navigation from '../modules/navigation';
import breaker from '../modules/breaker';
import ingredientsMiniList from '../modules/ingredients-mini-list';
import recipeMedia from '../modules/recipe-media';
import recipeSteps from '../modules/recipe-steps';
import productDetailHero from '../modules/product-detail-hero';
import nutritionalModal from '../modules/nutritional-modal';
import ingredientsList from '../modules/ingredients-list';
import ourProducts from '../modules/our-products';
import scroller from '../modules/conversion-table';
import footer from '../modules/footer';
import backgroundPattern from '../modules/backgroundPattern';
import media from '../modules/media';

//helpers
import { scrollObserver } from '../../util/helpers';
import '../../util/a11y/focus-visible';

export default {
  init() {
    // scroll observer helper
    scrollObserver();
    // JavaScript to be fired on all pages
    backgroundPattern.init();
    navigation.init();
    footer.init();
    sharer.init();
    youtubeBg.init();

    // modules used by multi pages
    dropcap.init();
    ingredientsList.init();
    ingredientsMiniList.init();
    nutritionalModal.init();
    ourProducts.init();
    productDetailHero.init();
    media.init();
    recipeMedia.init();
    scroller.init();
    breaker.init();
    recipeSteps.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/routes/common.js